module.exports = __webpack_public_path__ + "src/routes/home/Mindshare.png?81721f69";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/Mindshare.png
// module id = 917
// module chunks = 1